import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle} from '@angular/material/dialog';
import {MatButton} from '@angular/material/button';

@Component({
  selector: 'app-modal-content',
  standalone: true,
  imports: [
    MatDialogTitle,
    MatDialogClose,
    MatDialogContent,
    MatDialogActions,
    MatButton
  ],
  templateUrl: './modal-content.component.html',
  styleUrl: './modal-content.component.scss'
})
export class ModalContentComponent {

  // @ts-ignore
  constructor(@Inject(MAT_DIALOG_DATA) public htmlContent: string) {}

}
